import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class FichaEstoquePrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        if (this.props.buscaProduto.key) {
            axios
                .get('/estoque/listaFichaEstoque', {
                    params: {
                        print: true,
                        produto: this.props.buscaProduto.key,
                        tamanho: this.props.buscaProduto.pest_tamanho,
                        cor: this.props.buscaProduto.pest_cor,
                    }
                })
                .then(response => {
                    this.setState({
                        listaRegistros: response.data.consulta,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }



    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            return (
                <span></span>
            )
        }
    }


    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderQtdeEnt = (qtde, registro) => {
        if (registro.mi_ent_sai === 'E') {
            return (
                <span> {numeral(parseFloat(registro.mi_qtde)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderQtdeSai = (qtde, registro) => {
        if (registro.mi_ent_sai === 'S') {
            return (
                <span> {numeral(parseFloat(registro.mi_qtde)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderDescricao = (qtde, registro) => {
        let descricao = '';
        if (registro.mi_ent_sai === 'E') {
            if (registro.mi_tipo_mov === 'COM') {
                descricao = '[COMPRA] Nº ' + registro.com_numero + ' ' + registro.pes_nome_for;
            } else if (registro.mi_tipo_mov === 'CAD') {
                descricao = '[CADASTRO]';
            } else if (registro.mi_tipo_mov === 'INV') {
                descricao = '[AJUSTE ESTOQUE]';
            }
        } else {
            if (registro.mi_tipo_mov === 'VEN') {
                descricao = '[VENDA] Nº ' + registro.ven_numero + ' ' + registro.pes_nome_cli;
            } else if (registro.mi_tipo_mov === 'CON') {
                descricao = '[CONDICIONAL] Nº ' + registro.ven_numero + ' ' + registro.pes_nome_cli;
            } else if (registro.mi_tipo_mov === 'INV') {
                descricao = '[AJUSTE ESTOQUE]';
            }
        }
        return (
            <span>{descricao}</span>
        );
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Ficha Estoque
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Produto: </span>
                                <span>{this.props.buscaProduto.label}</span>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Estoque Atual: </span>
                                <span>R$ {this.renderValor(this.props.qtdeEstoque)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Custo: </span>
                                <span>R$ {this.renderValor(this.props.vlrvlrCusto)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Venda: </span>
                                <span>R$ {this.renderValor(this.props.vlrVenda)}</span>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="mi_data"
                                    dataIndex="mi_data"
                                    title="Data"
                                    render={this.renderData}
                                    width={120}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    title="Entrada"
                                    render={this.renderQtdeEnt}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    title="Saídas"
                                    render={this.renderQtdeSai}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_total"
                                    dataIndex="mi_vlr_total"
                                    title="Vlr Total"
                                    render={this.renderValor}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_qtde_estoque"
                                    dataIndex="mi_qtde_estoque"
                                    title="Qtde Est"
                                    render={this.renderValor}
                                    width={120}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_ent_sai"
                                    dataIndex="mi_ent_sai"
                                    title="Descrição"
                                    width={600}
                                    align="left"
                                    className="listaCadastro"
                                    render={this.renderDescricao}
                                />
                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default FichaEstoquePrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/FichaEstoquePrintModal.js